export const BENEFITS_AT_WORK_PROMO_CODE = '40BAW26'
export const BENEFITS_AT_WORK_SIMULATION_SO = 'Benefits At Work'
export const BENEFITS_AT_WORK_PLATFORM_COST_REDUCTION = 0.4 // 40%
